<template>
  <div v-lazy-bg="banner?.pictures?.[screen]?.src" class="subscribe">
    <div>
      <h2 class="subscribe__title">{{ messages?.title }}</h2>
      <p class="subscribe__text">{{ messages?.gift }}</p>
    </div>
    <form class="subscribe-form" @submit.prevent="handlerSubmit">
      <input type="hidden" name="action" :value="addSubscriber?.['params-example-data'].action" />
      <DefEmail
        :name="emailProps?.name"
        :required="emailProps?.required"
        :placeholder="emailProps?.placeholder"
        :is-error="componentData?.response?.status === false"
        :is-success="componentData?.response?.status === true"
      >
        <template #error>
          {{ componentData?.response.text }}
        </template>
        <template #success>
          {{ componentData?.response.text }}
        </template>
      </DefEmail>
      <DefButtonPrimary type="submit" :big="true">
        <svg class="subscribe-form__letter">
          <use xlink:href="#svg-letter"></use>
        </svg>
        {{ messages?.button }}
      </DefButtonPrimary>
    </form>
  </div>
</template>

<script lang="ts" setup>
import DefEmail from '@components/Def/DefEmail/DefEmail.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import { computed, reactive } from 'vue';
import useDeviceInfo from '@use/useDeviceInfo';
import { useResultsStore } from '@/storePinia/stores/results';

const { screen } = useDeviceInfo();
const resultsStore = useResultsStore();

const emailProps = computed(() => resultsStore.subscribe?.inputs?.DefEmail);
const messages = computed(() => resultsStore.subscribe?.messages);
const banner = computed(() => resultsStore.subscribe?.banners?.[0]);
const addSubscriber = computed(() => resultsStore.subscribe?.routes?.addSubscriber);

const componentData = reactive({ response: {} });

const handlerSubmit = async (e: SubmitEvent) => {
  try {
    const form = e.target as HTMLFormElement;
    if (form) {
      const formData = new FormData(form);

      const { status, data } = await axios.post(addSubscriber.value?.path, formData);

      if (status !== 200) {
        throw `bad request response status: ${status} \n url: ${path}`;
      }

      componentData.response = data?.response;
    }
  } catch (err) {
    console.error(err);
  }
};
</script>

<style lang="scss" scoped>
.subscribe {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  padding: 32px 24px;
  color: #fff;
  grid-row-gap: 24px;
  margin-bottom: 60px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  @include point-lg {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-column-gap: 40px;
    padding: 45px 40px;
    align-items: center;
    margin-bottom: 80px;
  }
  &__title {
    font-family: 'PT Serif';
    font-size: 24px;
    font-style: italic;
    font-weight: 400;
    line-height: 135%;
    text-transform: uppercase;
    margin-bottom: 8px;
    @include point-md {
      font-size: 28px;
    }
  }
  &__text {
    font-size: 16px;
    font-weight: 500;
    line-height: 125%;
    @include point-lg {
      font-size: 18px;
    }
  }
}
.subscribe-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  @include point-md {
    flex-direction: row;
  }
  &__letter {
    width: 20px;
    height: 20px;
    fill: #fff;
  }
  :deep(.def-button-primary) {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  :deep(.def-email) {
    flex-grow: 1;
    border-color: #fff;
    @include point-md {
      margin-bottom: 0;
    }
    .def-email__placeholder,
    .def-email__input {
      color: #fff;
    }
    &::placeholder {
      color: currentColor;
    }
  }
  :deep(.def-email_invalid) {
    border-color: var(--color-red);
  }
  :deep(.def-email_success) {
    border-color: #0ab35e;
  }
}
</style>
